import { Component } from "@theme/component";

/**
 * Metafield-based TurnTo review stars web component
 *
 * Usage:
 * <turnto-stars
 * data-rating="4.4"
 * data-count="92"
 * data-is-block="true"
 * data-test-ratings>
 * </turnto-stars>
 */
export class TurnToStars extends Component {
  static STAR_MAX = 5;

  connectedCallback() {
    super.connectedCallback();

    let rating = parseFloat(this.dataset.rating) || 0;
    let count = parseInt(this.dataset.count, 10) || 0;

    // Fixed shorthand: evaluates to true if attribute is "true"
    let block = this.dataset.isBlock === "true";

    const forceShow = this.hasAttribute("data-test-ratings");

    // Logic for generating random test data (4-5 stars)
    if (forceShow) {
      rating = Math.round((Math.random() * (5 - 4) + 4) * 10) / 10;
      count = Math.floor(Math.random() * (500 - 10 + 1)) + 10;
    }

    const hasData = rating > 0 || count > 0;

    if (!hasData && !forceShow) {
      this.style.display = "none";
      return;
    }

    const isFallback = forceShow && !(parseFloat(this.dataset.rating) > 0);

    this.render(rating, count, isFallback, block);
  }

  /**
   * @param {number} rating
   * @param {number} count
   * @param {boolean} isFallback
   * @param {boolean} block
   */
  render(rating, count, isFallback, block) {
    const rounded = Math.max(0, Math.min(TurnToStars.STAR_MAX, rating)).toFixed(
      1,
    );

    const ariaLabel =
      count > 0
        ? `Rated ${rounded} out of 5 stars based on ${count} reviews`
        : `Rated ${rounded} out of 5 stars`;

    this.innerHTML = `
      <div
        class="turnto-stars ${isFallback ? "is-fallback" : ""} ${block ? "is-block" : ""}"
        role="img"
        aria-label="${ariaLabel}"
        style="--rating:${rounded}"
      >
        <span class="stars" aria-hidden="true"></span>
        ${!block ? `<span class="count" aria-hidden="true">(${count})</span>` : ""}
        <span class="sr-only">${ariaLabel}</span>
      </div>
    `;
  }
}

if (!customElements.get("turnto-stars")) {
  customElements.define("turnto-stars", TurnToStars);
}
